export default __webpack_public_path__ + "static/media/drone.3e700e1a.jpg";